<template>
    <div class="h-100">
        <div style="display: flex;
    justify-content: space-between;">
            <div style="text-align: initial;
                padding-inline-start: 2%;">
                <h6 class="ml-2 mb-0 pt-3 pb-1" style="color: #b5b5b5">Jobs</h6>
            </div>
        </div>
        <div class="widget-sub-wrapper">
            <div v-if="Object.keys(jobsDashboardData).includes('queued')" @click="redirectToJobsPage('QUEUED')" class="widget-sub-styles">
                <div class="widget-sub-heading">{{$t('Queued')}}</div>
                <div class="widget-sub-value">{{jobsDashboardData.queued}}</div>
            </div>
            <div v-if="Object.keys(jobsDashboardData).includes('inprogress')" @click="redirectToJobsPage('IN_PROGRESS')" class="widget-sub-styles">
                <div class="widget-sub-heading">{{$t('In Progress')}}</div>
                <div class="widget-sub-value">{{jobsDashboardData.inprogress}}</div>
            </div> 
            <div v-if="Object.keys(jobsDashboardData).includes('completed')" @click="redirectToJobsPage('COMPLETED',true)" class="widget-sub-styles">
                <div class="widget-sub-heading"><div>{{$t('Completed')}}</div><div style="font-size: 12px;text-align: start;">today's</div></div>
                <div class="widget-sub-value">{{jobsDashboardData.completed}}</div>
            </div>
            <div v-if="Object.keys(jobsDashboardData).includes('failed')" @click="redirectToJobsPage('FAILED',true)" class="widget-sub-styles">
                <div class="widget-sub-heading"><div>{{$t('Failed')}}</div><div style="font-size: 12px;text-align: start;">today's</div></div>
                <div class="widget-sub-value">{{jobsDashboardData.failed}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";

export default ({
    data(){
        return{
            jobsDashboardData:{},
            openDashboardPluginStore:false
        }
    },
    methods:{
        redirectToJobsPage(status, enableTodayFilter=false){
            let route = {name: 'jobs'};
            route.params = {parentinfo:Object.assign({forceRedirect:true},this.$route)};
            let currentDate = moment(new Date()).format("YYYY-MM-DD");
            if(enableTodayFilter){
                route.query = {state:status, user_id:'all', from_date:currentDate ,to_date:currentDate};
            }else{
                route.query = {state:status, user_id:'all'};
            }
            this.$router.push(route).catch(()=>{});
        },
        ...mapActions("dashboard", ["getJobsWidgetDataFromServer"]),
    },
    created(){
        this.getJobsWidgetDataFromServer().then((data) => {
            this.jobsDashboardData = data;
        })
    }
})
</script>


<style lang="scss" scoped>
    $active-green-icon-color: #00ff3a;
    $count-bg-color:#e7c20b;
    $count-border-color:#373737;
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $panel-heading-font-size:18px;
    $secondary-border-color: 1px solid #2b2b2b;
    $widgets-bg-color: #202729;
    
    .icon-background-on-hover:hover{
        background: #d1d2d31a;
    }

    .icon-background-on-hover{
        padding: 6px;
        height: 40px;
        width: 45px;
        border-radius: 4px;
        margin: 4px;
    }

    .widget-sub-wrapper{
        display: grid;
        gap: 12px;
        grid-gap: 5px;
        grid-template-columns: 50% 50% !important;
        padding: 10px;
        height: 86%;
        .widget-sub-styles{
            background: $widgets-bg-color;
            margin: 4%;
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            border-radius: 4px;
            box-shadow: 0px 0px 9px 1px #1a1a1a;
            height:140px;
            position: relative;
            .widget-sub-heading{
                font-size: 15px;
                display: flex;
                position: absolute;
                inset-inline-start:8%;
                top: 4%;
                color: #a7a7a7;
                flex-flow: column;
            }
            .widget-sub-value{
                font-size: 50px;
                color: #cfcfcf;
                margin: 12%;
            }
        }
    }

      @media only screen and (max-width: 900px) {
        .widget-sub-wrapper {
            display: flex;
            flex-direction: column; 
        }
    }

    
</style>